import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const GetAllObjectivesAndActivitiesByAppGuid = createAsyncThunk(
  "ObjectivesAndActivities/GetAllObjectivesAndActivitiesByAppGuid",
  async (parameters, { rejectWithValue }) => {
    try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
            "api/SU_NT_WPB_ObjectivesAndActivities/GetAllObjectivesAndActivitiesByAppGuid",
            parameters
          );

          const data = response.data.result; // Assuming response has a "data" field
          return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetObjectivesAndActivitiesById = createAsyncThunk(
    "ObjectivesAndActivities/GetObjectivesAndActivitiesById",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ObjectivesAndActivities/GetObjectivesAndActivitiesById",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const AddObjectivesAndActivities = createAsyncThunk(
    "ObjectivesAndActivities/AddObjectivesAndActivities",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ObjectivesAndActivities/AddObjectivesAndActivities",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const EditObjectivesAndActivities = createAsyncThunk(
    "ObjectivesAndActivities/EditObjectivesAndActivities",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ObjectivesAndActivities/EditObjectivesAndActivities",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const DeleteObjectivesAndActivities = createAsyncThunk(
    "ObjectivesAndActivities/DeleteObjectivesAndActivities",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ObjectivesAndActivities/DeleteObjectivesAndActivities",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );




  export const GetObjectivesAndActivitiesDropDown = createAsyncThunk(
    "ObjectivesAndActivities/GetObjectivesAndActivitiesDropDown",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/DropDowns/GetObjectivesAndActivities",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            console.log(data,"sdsdsdwdewdwdsdsd");

            return data; // Return the extracted data

            
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


const ObjectivesAndActivitiesReducers = createSlice({
  name: "FetchDataJson",
  initialState: {
    ObjectivesAndActivitiesList: {},
    loadingObjectivesAndActivitiesList: false,
    errorObjectivesAndActivitiesList: null,

    ObjectivesAndActivities: {},
    loadingObjectivesAndActivities: false,
    errorObjectivesAndActivities: null,

    AddObjectivesAndActivities: {},
    loadingAddObjectivesAndActivities: false,
    errorAddObjectivesAndActivities: null,

    EditObjectivesAndActivities: {},
    loadingEditObjectivesAndActivities: false,
    errorEditObjectivesAndActivities: null,

    DeleteObjectivesAndActivities: {},
    loadingDeleteObjectivesAndActivities: false,
    errorDeleteObjectivesAndActivities: null,


    ObjectivesAndActivitiesDropDown: [],
    loadingObjectivesAndActivitiesDropDown: false,
    errorObjectivesAndActivitiesDropDown: null,

  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllObjectivesAndActivitiesByAppGuid.pending, (state, action) => {
        state.loadingObjectivesAndActivitiesList = true;
        state.ObjectivesAndActivitiesList = action.payload;
        state.errorObjectivesAndActivitiesList = null;
      })
      .addCase(GetAllObjectivesAndActivitiesByAppGuid.fulfilled, (state, action) => {
        state.loadingObjectivesAndActivitiesList = false;
        state.ObjectivesAndActivitiesList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllObjectivesAndActivitiesByAppGuid.rejected, (state, action) => {
        state.loadingObjectivesAndActivitiesList = false;
        state.errorObjectivesAndActivitiesList = action.payload;
      });

      builder
      .addCase(GetObjectivesAndActivitiesById.pending, (state, action) => {
        state.loadingObjectivesAndActivities = true;
        state.ObjectivesAndActivities = action.payload;
        state.errorObjectivesAndActivities = null;
      })
      .addCase(GetObjectivesAndActivitiesById.fulfilled, (state, action) => {
        state.loadingObjectivesAndActivities = false;
        state.ObjectivesAndActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetObjectivesAndActivitiesById.rejected, (state, action) => {
        state.loadingObjectivesAndActivities = false;
        state.errorObjectivesAndActivities = action.payload;
      });

      builder
      .addCase(AddObjectivesAndActivities.pending, (state, action) => {
        state.loadingAddObjectivesAndActivities = true;
        state.AddObjectivesAndActivities = action.payload;
        state.errorAddObjectivesAndActivities = null;
      })
      .addCase(AddObjectivesAndActivities.fulfilled, (state, action) => {
        state.AddObjectivesAndActivities = false;
        state.ObjectivesAndActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddObjectivesAndActivities.rejected, (state, action) => {
        state.loadingAddObjectivesAndActivities = false;
        state.errorAddObjectivesAndActivities = action.payload;
      });

      builder
      .addCase(EditObjectivesAndActivities.pending, (state, action) => {
        state.loadingEditObjectivesAndActivities = true;
        state.EditObjectivesAndActivities = action.payload;
        state.errorEditObjectivesAndActivities = null;
      })
      .addCase(EditObjectivesAndActivities.fulfilled, (state, action) => {
        state.AddObjectivesAndActivities = false;
        state.EditObjectivesAndActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditObjectivesAndActivities.rejected, (state, action) => {
        state.loadingEditObjectivesAndActivities = false;
        state.errorEditObjectivesAndActivities = action.payload;
      });

      builder
      .addCase(DeleteObjectivesAndActivities.pending, (state, action) => {
        state.loadingDeleteObjectivesAndActivities = true;
        state.DeleteObjectivesAndActivities = action.payload;
        state.errorDeleteObjectivesAndActivities = null;
      })
      .addCase(DeleteObjectivesAndActivities.fulfilled, (state, action) => {
        state.AddObjectivesAndActivities = false;
        state.DeleteObjectivesAndActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteObjectivesAndActivities.rejected, (state, action) => {
        state.loadingDeleteObjectivesAndActivities = false;
        state.errorDeleteObjectivesAndActivities = action.payload;
      });


      builder
      .addCase(GetObjectivesAndActivitiesDropDown.pending, (state, action) => {
        state.loadingObjectivesAndActivitiesDropDown = true;
        state.ObjectivesAndActivitiesDropDown = action.payload;
        state.errorObjectivesAndActivitiesDropDown = null;
      })
      .addCase(GetObjectivesAndActivitiesDropDown.fulfilled, (state, action) => {
        state.loadingObjectivesAndActivitiesDropDown = false;
        state.ObjectivesAndActivitiesDropDown = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetObjectivesAndActivitiesDropDown.rejected, (state, action) => {
        state.loadingObjectivesAndActivitiesDropDown = false;
        state.errorObjectivesAndActivitiesDropDown = action.payload;
      });

  },
});






export default ObjectivesAndActivitiesReducers.reducer;
